import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'

import UserLetterDetailPage from '@/features/user/letter/pages/UserLetterDetailPage'
import { TYPE_HealthDataList } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useLetterDataQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { useMoreButton } from '@/shared/hooks/useMoreButton'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import { LetterItems, LetterItemsList } from '@/styles/views/UserPage/letter'

const LetterHealth = () => {
  const [more, onChangeMore, setMore] = useMoreButton(0)
  const { data: LetterListData, isSuccess } = useLetterDataQueryData(TYPE_HealthDataList, more)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { width } = useWindowDimensions()

  useEffect(() => {
    setMore(0)
  }, [setMore])

  return (
    <>
      {pathname?.indexOf('detail') > 0 ? (
        <UserLetterDetailPage detailInfo={'health'} />
      ) : (
        <>
          <LetterItemsList>
            {isSuccess &&
              LetterListData?.Body.length !== 0 &&
              LetterListData?.Body?.map(
                (element: { Title: string; ImgPath: string; Idx: number }, index: number) => (
                  <LetterItems
                    key={index}
                    onClick={() => navigate(`/userPage/letter/health/detail/${element.Idx}`)}
                  >
                    <img src={`https://${element?.ImgPath}`} alt="" />
                    <p>{element?.Title}</p>
                  </LetterItems>
                ),
              )}
          </LetterItemsList>
          {LetterListData?.Body?.length >= (more + 1) * 6 && (
            <CustomBtn
              className={width > 1200 ? 'health_btn_pc' : 'health_btn_mo'}
              color={COLOR.point1}
              bgColor={COLOR.white}
              borderRadius={'40px'}
              borderColor={COLOR.point1}
              marginTop={width > 1200 ? '51px' : '24px'}
              width={width > 1200 ? '356px' : '328px'}
              height={width > 1200 ? '56px' : '44px'}
              fontSize={width > 1200 ? '18px' : '14px'}
              fontFamily={
                width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'
              }
              onClick={onChangeMore}
            >
              <span>더보기</span>
            </CustomBtn>
          )}
        </>
      )}
    </>
  )
}
export default LetterHealth
